import Calendar from "../../Calendar/Calendar";
import {useEffect, useState} from "react";
import {retrieveTrainingPlans} from "../../../Api/Teams/Trainings/TrainingsFetch";

const generateEventsFromPlans = (plans, color) => {
    const events = [];
    plans.forEach(plan => {
        const startDate = new Date(plan.start_date);
        const endDate = new Date(plan.end_date);

        plan.plan.forEach(slot => {
            const targetDay = parseInt(slot.day); // 0=Dom, 1=Lun, ..., 6=Sab

            // Trova la prima data >= startDate con il giorno della settimana corretto
            const current = new Date(startDate);
            const daysUntilTarget = (targetDay - current.getDay() + 7) % 7;
            current.setDate(current.getDate() + daysUntilTarget);

            // Itera ogni settimana fino a endDate
            while (current <= endDate) {
                const dateStr = current.toISOString().slice(0, 10);
                events.push({
                    start: `${dateStr}T${slot.start_time}:00`,
                    end: `${dateStr}T${slot.end_time}:00`,
                    title: plan.location,
                    color: color || 'var(--secondary)',
                    borderColor: 'transparent',
                    display: 'block',
                });
                current.setDate(current.getDate() + 7);
            }
        });
    });
    return events;
};

const Trainings = (props) => {
    const [events, setEvents] = useState([])
    const [color, setColor] = useState()
    const [isAll, setIsAll] = useState(false);
    const [trainingPlans, setTrainingPlans] = useState([]);

    useEffect(() => {
        if (props.teamDetails) {
            setColor(props.teamDetails.color);
        }
    }, [props.teamDetails]);

    useEffect(() => {
        if (props.teamDetails?.id) {
            retrieveTrainingPlans({setTrainingPlans, id: props.teamDetails.id});
        }
    }, [props.teamDetails?.id]);

    useEffect(() => {
        setEvents(generateEventsFromPlans(trainingPlans, color));
    }, [color, trainingPlans]);

    return (
        <>
            <Calendar events={events} height={600} setEvents={setEvents} id={props.teamDetails && props.teamDetails.id}
                      team_id={props.teamDetails && props.teamDetails.id}
                      isAll={isAll}
                      setTeamDetail={props.setTeamDetail} initalview={'dayGridMonth'}></Calendar>
        </>
    )
}

export default Trainings